const shouldBeSelectable = (isSelectable: boolean | undefined): boolean =>
  isSelectable === undefined || isSelectable === true;

export default shouldBeSelectable;
